import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useCallback, useContext, useEffect, useRef, useState, useMemo } from "react";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "../../../components/FormInput";
import { FormInputFile } from "../../../components/FormInputFile";
import { FormInputSearch } from "../../../components/FormInputSearch";
import { FormTextarea } from "../../../components/FormTextarea";
import ImagePDFComponent from "../../../components/ImagePDFComponent";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { MessageContext, handleSuccessMessage } from "../../../store/messageStore";
import { AlertService } from "../../../utility/service/alert-service";
import { handleFileDownloadRes } from "../../../utility/service/api-base";
import { downloadMultipartFile } from "../../../utility/service/api-file";
import { getSubItemsByItemNo } from "../../../utility/service/api-service";
import {
  CreateSubTypeDevice,
  F1010322Before,
  F1010328Before,
  queryClassNoTypeList,
  queryClassProcessList,
  queryIdentifyDetailList,
  queryMaterialList,
  querySubTypeDeviceList,
  queryTypeSubTypeSourceList,
} from "../../../utility/service/carbon-service";
import {
  checkDpSuccess,
  getFormErrorMessage,
  splitFileExtension,
  splitFileName,
} from "../../../utility/service/tool-service";
import { addFormValidator } from "../../../utility/validate/formValidator";
import CarbonCoefficientComponent from "../../inventoryCarbonFootprint/cusComponents/CarbonCoefficientComponent";
import EmissionSourceDialog from "./EmissionSourceDialog";
// 新增國際化數字輸入元件 import
import FormNumberInput from "../../../components/FormNumberInput";
// 新增 NumberUtil import 以支援數值格式化
import PrimePanel from "../../../components/PrimePanel";
import NumberUtil from "../../../utility/NumberUtil";
import { isGeneral, isManufacturing } from "../constants/inventoryType";

const AddItem = ({
  handleSubmit,
  control,
  register,
  errors,
  criterion,
  setValue,
  itemObj,
  getValues,
  clearErrors,
  fileInputRef,
  actionStatus,
  editObj,
  customFileInputRef,
  watch,
  trigger,
  isEditable,
  gwpVersion,
  companyPlaceList,
  boudaryDeviceList,
  planType,
}) => {
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const { t } = useTranslation();
  const [type, setType] = useState("0");
  const [addChecked, setChecked] = useState(false);
  const [isCalculate, setCalculate] = useState(true);
  const [classList, setClassList] = useState([]);
  const [processList, setProcessList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [deviceList, setDeviceList] = useState([]); //設備
  const [sourceList, setSourceList] = useState([]); //排放源
  const [previewUrl, setPreviewUrl] = useState(null);
  const [zoomSrc, setZoomSrc] = useState(null);
  // const [cusPreviewUrl, setCusPreviewUrl] = useState(null);
  // const [cusZoomSrc, setCusZoomSrc] = useState(null);
  const [fileInfo, setFileInfo] = useState({});
  const [CusfileInfo, setCusFileInfo] = useState({});
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [materialCodeList, setMaterialCodeList] = useState([]);
  const [formRule, setFormRule] = useState([]); //表單驗證 設備
  const [formRule2, setFormRule2] = useState([]); //表單驗證 建立
  const [showIndex, setShowIndex] = useState(false);
  const [showEmissionSourceDialog, setShowEmissionSourceDialog] = useState(false);
  const cusCoeRef = useRef();
  const [previewCusUrl, setPreviewCusUrl] = useState(null);
  const [zoomCusSrc, setZoomCusSrc] = useState(null);
  //係數種類
  const [rateTypeList, setRateTypeList] = useState([]);
  const [identifyDetailList, setIdentifyDetailList] = useState([]); //排放源鑑別範疇/類別
  const [isIdentifyDetailExpanded, setIsIdentifyDetailExpanded] = useState(true); //控制排放源鑑別表格展開/縮合

  // 事業主管機關、證書字號、納管行業別、納管條件：僅在「非通用行業」且「非製造業」時顯示
  const showRegulatedFields = planType != null && !isGeneral(planType) && !isManufacturing(planType);

  const disabledCondition = !isEditable || actionStatus === "detail";

  const deviceMap = useMemo(() => {
    const map = new Map();
    boudaryDeviceList.forEach((d) => {
      map.set(d.placeDeviceSeq, d);
    });
    return map;
  }, [boudaryDeviceList]);

  const placeMap = useMemo(() => {
    const map = new Map();
    companyPlaceList.forEach((p) => {
      map.set(p.placeSeq, p);
    });
    return map;
  }, [companyPlaceList]);

  // 根據盤查規範判斷 f1010325 的 class 參數
  // 既有邏輯：criterion === "0" -> "S"；其餘預設 "C"
  // 新增：當規範選擇 G:GHG Protocol 時，改帶 "9"
  const getClassCodeByCriterion = () => {
    if (criterion === "0") return "S";
    if (criterion === "9") return "G";
    return "C";
  };

  // ==============================
  // G 模式下：classNo=103 內部仍需依 typeSeq 對應回 C 的 classNo（3/4/5/6）
  // 若映射回 C classNo=3（排放源係數），則不顯示「碳足跡係數 / 自定義係數」區塊。
  // ==============================
  const isGhgMode = criterion === "9";
  // 使用 watch 才能在 typeSeq/subType 變更時重新 render
  const watchedClassNo = watch("classSeq")?.classNo;
  const watchedTypeSeqObj = watch("typeSeq");
  const watchedSubTypeObj = watch("subType");
  const watchedHasSubTypeList = Boolean(watchedTypeSeqObj?.subTypeList?.length > 0);

  // 前端表單的 typeSeq/ghgTypeSeq 可能是 RandomSeqLongUtil.toHexString 的編碼字串（如 0_00000bb9）
  // 這裡先還原成 Long value，才能套用 GhgClassMappingUtil 的 typeSeq 對照表。
  const decodeRandomSeqLongToLongValue = (hexValue) => {
    if (hexValue == null || hexValue === "") return null;
    if (typeof hexValue === "number") return hexValue;
    const s = String(hexValue);
    if (!s.includes("_")) {
      const n = Number(s);
      return Number.isNaN(n) ? null : n;
    }
    const arr = s.split("_");
    if (arr.length < 2) return null;
    let dateHex = arr[0];
    const timeHex = arr[1];
    // 對齊 RandomSeqLongUtil.toLongValue(String hexValue)
    if (timeHex.length === 10) {
      dateHex = dateHex + "0000000000";
    } else {
      dateHex = dateHex + "00000000";
    }
    const longDate = parseInt(dateHex, 16);
    const longTime = parseInt(timeHex, 16);
    if (Number.isNaN(longDate) || Number.isNaN(longTime)) return null;
    return longDate + longTime;
  };

  const parseTypeSeqLong = (value) => decodeRandomSeqLongToLongValue(value);

  const watchedGhgTypeSeqFor103 = (() => {
    const raw = watchedHasSubTypeList ? watchedSubTypeObj?.typeSeq : watchedTypeSeqObj?.typeSeq;
    return parseTypeSeqLong(raw);
  })();
  const ghgTypeSeqToCTypeSeqMap = {
    1001: 1,
    1002: 2,
    1003: 3,
    1004: 4,
    1005: 5,
    1006: 8,
    1007: 9,
    1008: 6,
    1009: 10,
    1010: 5,
    1011: 9,
    1012: 32,
    2001: 11,
    2002: 12,
    3001: 22,
    3002: 23,
    3003: 24,
    3004: 16,
    3005: 26,
    3006: 20,
    3007: 18,
    3008: 25,
    3009: 17,
    3010: 28,
    3011: 29,
    3012: 30,
    3013: 32,
    3014: 31,
    3015: 31,
  };

  const getMappedCClassNoWhenGhgClassNo103 = (ghgTypeSeq) => {
    const typeSeqNum = parseTypeSeqLong(ghgTypeSeq);
    if (typeSeqNum == null) return 3;

    // 1) 先把 GHG typeSeq 映射回 C typeSeq（對齊 GhgClassMappingUtil：TYPESEQ_G_TO_C）
    const mappedTypeSeq = ghgTypeSeqToCTypeSeqMap[typeSeqNum] ?? typeSeqNum;

    // 2) 再用「映射後的 C typeSeq」回推合併後的 C classNo（3/4/5/6）
    if (mappedTypeSeq >= 16 && mappedTypeSeq <= 21) return 3;
    if (mappedTypeSeq >= 22 && mappedTypeSeq <= 26) return 4;
    if (mappedTypeSeq >= 28 && mappedTypeSeq <= 31) return 5;
    if (mappedTypeSeq === 32) return 6;
    return 3;
  };

  // 是否走「碳足跡係數 / 自定義係數」區塊
  const isCarbonCoefficientMode = (() => {
    const classNo = watchedClassNo;
    if (classNo == null || classNo === "") return false;

    if (!isGhgMode) {
      return classNo === "4" || classNo === "5" || classNo === "6";
    }

    if (classNo === "103") {
      const mappedCClassNo = getMappedCClassNoWhenGhgClassNo103(watchedGhgTypeSeqFor103);
      return mappedCClassNo === 4 || mappedCClassNo === 5 || mappedCClassNo === 6;
    }

    // 保底：若後端未來出現 4/5/6 於 G 模式，也照一般規則
    return classNo === "4" || classNo === "5" || classNo === "6";
  })();

  // 設備編號依 場所 + 範疇/類別 + 排放源型式 篩選
  const selectedPlanPlaceSeq = watch("planPlaceSeq");
  const selectedClassNo = watchedClassNo;
  const selectedTypeSeq = watchedSubTypeObj?.typeSeq ?? watchedTypeSeqObj?.typeSeq;
  const filteredPlaceDeviceList = useMemo(() => {
    if (selectedPlanPlaceSeq == null || selectedPlanPlaceSeq === "" || !boudaryDeviceList?.length) {
      return [];
    }
    const place = companyPlaceList?.find((p) => p.planPlaceSeq === selectedPlanPlaceSeq);
    const placeSeq = place?.placeSeq;
    if (placeSeq == null) return [];
    return boudaryDeviceList
      .filter((d) => {
        if (d.placeSeq != placeSeq) return false;
        if (selectedClassNo != null && selectedClassNo !== "" && d.classNo != selectedClassNo) return false;
        if (selectedTypeSeq != null && selectedTypeSeq !== "" && d.typeSeq != selectedTypeSeq) return false;
        return true;
      })
      .map((d) => ({
        ...d,
        displayLabel: [d.placeDeviceNo, d.deviceName].filter(Boolean).join(" "),
      }));
  }, [selectedPlanPlaceSeq, selectedClassNo, selectedTypeSeq, companyPlaceList, boudaryDeviceList]);

  // 當篩選條件變更後，若目前選的設備編號已不在清單內則清空
  const currentPlaceDeviceSeq = watch("placeDeviceSeq");
  useEffect(() => {
    if (currentPlaceDeviceSeq == null || currentPlaceDeviceSeq === "") return;
    const stillInList = filteredPlaceDeviceList.some((d) => d.placeDeviceSeq === currentPlaceDeviceSeq);
    if (!stillInList) {
      setValue("placeDeviceSeq", undefined);
    }
  }, [filteredPlaceDeviceList, currentPlaceDeviceSeq, setValue]);

  // 根據不同情境設定標題
  const getHeaderByContext = (field, context) => {
    switch (context) {
      // 製程：焊條  含碳量
      case "case1-2":
        const carbonRateHeaders = {
          carbonRate: t("carbon_content"),
          gasRate: t("gasRate"),
        };
        return carbonRateHeaders[field] || field;
      // 逸散：冷煤  逸散率
      case "case1-4":
        const deviceTypeAHeaders = {
          otherRate1: t("escape_rate"),
          gasRate: t("gasRate"),
        };
        return deviceTypeAHeaders[field] || field;
      // 逸散：滅火器  殘留率
      case "case1-5":
        const deviceTypeBHeaders = {
          otherRate1: t("residue_rate"),
          gasRate: t("gasRate"),
        };
        return deviceTypeBHeaders[field] || field;
      // 逸散：氣體斷路器  洩漏率
      case "case1-6":
        const emissionTypeCHeaders = {
          otherRate1: t("leak_rate"),
          gasRate: t("gasRate"),
        };
        return emissionTypeCHeaders[field] || field;
      // 逸散：化糞池 排放係數
      case "case1-7":
        const emissionTypeDHeaders = {
          otherRate1: t("gasRate"),
          gasRate: t("gasRate"),
        };
        return emissionTypeDHeaders[field] || field;
      // 逸散：廢水處理廠 排放係數
      case "case1-8":
        const customTypeGHeaders = {
          otherRate1: t("cod"),
          otherRate2: t("bo"),
          otherRate3: t("mcf"),
          otherRate4: t("combustion"),
          gasRate: t("gasRate"),
        };
        return customTypeGHeaders[field] || field;
      // 逸散：噴霧劑
      case "case1-9":
        const customTypeHHeaders = {
          otherRate1: t("gasProportion"),
          gasRate: t("gasDensity"),
        };
        return customTypeHHeaders[field] || field;

      default:
        // 預設情境
        const defaultHeaders = {
          carbonRate: t("carbon_content"),
          otherRate1: "其他比率",
          otherRate2: "其他比率",
          otherRate3: "其他比率",
          otherRate4: "其他比率",
          gasRate: t("gasRate"),
        };
        return defaultHeaders[field] || field;
    }
  };

  // 獲取當前情境（根據 type 和 subType 定義）
  const getCurrentContext = () => {
    const type = getValues("typeSeq")?.type;
    const subType = getValues("subType")?.subType;

    // 根據 type 和 subType 的組合來定義情境
    if (type === "P") {
      return "case1-2";
    } else if (type === "F" && subType === "R") {
      return "case1-4";
    } else if (type === "F" && subType === "F") {
      return "case1-5";
    } else if (type === "F" && subType === "G") {
      return "case1-6";
    } else if (type === "F" && subType === "S") {
      return "case1-7";
    } else if (type === "F" && subType === "W") {
      return "case1-8";
    } else if (type === "F" && subType === "P") {
      return "case1-9";
    } else {
      return "default";
    }
  };

  // 動態 otherRate 欄位設定
  const getOtherRateColumns = () => {
    const otherRateConfigs = [
      { field: "carbonRate", header: "carbonRate" },
      { field: "otherRate1", header: "otherRate1" },
      { field: "otherRate2", header: "otherRate2" },
      { field: "otherRate3", header: "otherRate3" },
      { field: "otherRate4", header: "otherRate4" },
    ];

    const currentContext = getCurrentContext();

    return otherRateConfigs
      .filter((config) => {
        // 檢查是否有任何資料包含該欄位的非空值
        return identifyDetailList.some(
          (row) => row[config.field] !== null && row[config.field] !== undefined && row[config.field] !== "",
        );
      })
      .map((config) => ({
        ...config,
        header: getHeaderByContext(config.field, currentContext),
      }));
  };

  // 檢查是否應該顯示 emissionFactorKgPerTJ 和 heatingValue 欄位
  const shouldShowEmissionFactorAndHeatingValueColumns = () => {
    const classNo = getValues("classSeq")?.classNo;
    const type = getValues("typeSeq")?.type;

    // 類一且類型為 T 或 E
    const originalCondition = classNo === "1" && (type === "T" || type === "E");

    // 有 emissionFactorKgPerTJ 資料就顯示
    const hasEmissionFactor = identifyDetailList.some(
      (row) =>
        row.emissionFactorKgPerTJ !== null &&
        row.emissionFactorKgPerTJ !== undefined &&
        row.emissionFactorKgPerTJ !== "",
    );

    return originalCondition || hasEmissionFactor;
  };

  // 使用 useWatch 監測 欄位
  const isCusCoefficentValue = useWatch({
    control,
    name: "isCusCoefficent", // 監測的欄位名稱
    defaultValue: "", // 初始值
  });

  const handlePickData = (rowData) => {
    setShowIndex(false);
    setValue("sourceName", rowData?.coefficientName, { shouldValidate: true });
    setValue("cusSourceSeq", rowData?.coefficientId, { shouldValidate: true });
    setValue("keywordSearch", "");
  };

  const handleEmissionSourcePick = (rowData) => {
    setShowEmissionSourceDialog(false);
    setValue("sourceName", rowData?.sourceName, { shouldValidate: true });
    setValue("sourceSeq", rowData?.sourceSeq, { shouldValidate: true });
    setValue("materialCode", rowData?.materialCode, { shouldValidate: true });

    // 處理特殊邏輯
    if (rowData?.sourceSeq === "0_0000005b") {
      setValue("isCalculate", false);
    }

    // 清空表格的編輯狀態，避免殘留舊資料
    setIdentifyDetailList([]);
    setValue("identifyDetailList", [], { shouldValidate: true });

    // 觸發排放源變更的相關邏輯
    triggerSourceSeqChange(rowData?.sourceSeq);
  };

  const btnSerchSourceName = () => {
    if (isCarbonCoefficientMode) {
      setShowIndex(true);
    } else {
      // 其他類別使用排放源開窗
      setShowEmissionSourceDialog(true);
    }
  };

  useEffect(() => {
    cusCoeRef?.current?.expand();
    if (
      isCarbonCoefficientMode &&
      isCusCoefficentValue === true
    ) {
      if (customFileInputRef?.current && customFileInputRef?.current?.files?.length !== 0) {
        setValue("customFile", customFileInputRef?.current?.files, { shouldValidate: true });
        trigger("customFile");
      }
    }
  }, [isCusCoefficentValue]);

  useEffect(() => {
    clearErrors("remark");
    trigger("remark");
  }, [watch("isCalculate")]);

  //zip 才能點下載
  const downloadItem = (rowData) => {
    if (
      getValues("customFileName") === rowData?.customFileName &&
      getValues("customFileExtension") === rowData?.customFileExtension &&
      rowData?.customFileId !== null
    ) {
      //存在於資料庫的才去call 下載API
      downloadMultipartFile({
        fileId: rowData?.customFileId,
      }).then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(res, `${rowData.customFileName}.zip`);
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      });
    } else {
      //還沒上傳到server的 用原始file 下載
      const reader = new FileReader();
      reader.onload = () => {
        // 檔案內容已載入，可以進行下載
        const fileContent = reader.result;
        const a = document.createElement("a");
        a.href = fileContent;
        a.download = `${getValues("customFileName")}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
      reader.readAsDataURL(getValues("customFile"));
    }
  };

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F1010322Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule2(array);
      }
    });
  };

  const setValidFormCreate = useCallback(
    (formId) => {
      if (formRule2?.length > 0) {
        const tmp = formRule2?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule2],
  );

  //排放源鑑別範疇/類別 criterion 0-> S ; criterion 1 -> C
  const axios_queryClassProcessList = (reqBody) => {
    queryClassProcessList(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        let result = res.data.RespBody;
        setClassList(result?.classList); //類別清單
        if (actionStatus === "edit" || actionStatus === "copy" || actionStatus === "detail") {
          let classNoStr = editObj?.classNo;
          let resArr = result?.classList?.filter((item) => item.classNo === classNoStr);
          setValue("classSeq", resArr[0]);
        }
        setProcessList(result?.processList);
      }
    });
  };

  const axios_queryClassProcessListByType = (reqBody = { type: "P" }) => {
    //排放源形式=製程排放源時篩選顯示"焊"相關 編輯和複製也需要判斷type為P 也要重call 待修正
    const finalReqBody = {
      class: getClassCodeByCriterion(),
      ...reqBody,
    };

    queryClassProcessList(finalReqBody).then((res) => {
      if (checkDpSuccess(res)) {
        let result = res.data.RespBody;
        setProcessList(result?.processList);
      }
    });
  };

  // 原燃物料code清單查詢
  const axios_queryMaterialList = () => {
    queryMaterialList().then((res) => {
      if (checkDpSuccess(res)) {
        setMaterialCodeList(res?.data?.RespBody?.materialList);
      }
    });
  };

  const axios_getDropdownData = () => {
    getSubItemsByItemNo("CFV_PLAN_MATERIAL", 13).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setMaterialTypeList(newArray);
      }
    });

    //係數種類
    getSubItemsByItemNo("CFV_RATE_TYPE", 16).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        setRateTypeList(data);
      }
    });
  };

  //排放源型式
  const axios_queryClassNoTypeList = (classNo, typeSeq) => {
    queryClassNoTypeList({ classNo }).then((res) => {
      if (checkDpSuccess(res)) {
        let result = res.data.RespBody?.typeList;
        setTypeList(result);
        if (typeSeq !== undefined) {
          setValue("quantity", editObj?.quantity, { shouldValidate: true });
          setValue("remark", editObj?.remark, { shouldValidate: true });
          // setValue("isCalculate",editObj?.isCalculate==='Y'?true:false, { shouldValidate: true });
          setValue("fileExtension", editObj?.fileExtension);
          setValue("fileName", editObj?.fileName);
          // 類四參數

          if (editObj?.customFileExtension !== null) {
            setZoomCusSrc(editObj?.customFilePath); //原圖
            if (editObj?.customFileExtension === "pdf" || editObj?.customFileExtension === "zip") {
              setPreviewCusUrl(editObj?.customFilePath); //原圖
            } else {
              setPreviewCusUrl(editObj?.customFilePathSml); //縮圖
            }
            setCusFileInfo({
              type: editObj?.customFileExtension,
              name: `${editObj?.customFileName}.${editObj?.customFileExtension}`,
            });
          }

          clearErrors(["remark"]);
          if (editObj?.fileExtension !== null) {
            // setPreviewUrl(editObj?.devicePic);
            setZoomSrc(editObj?.filePath); //原圖
            if (editObj?.fileExtension === "pdf") {
              setPreviewUrl(editObj?.filePath); //原圖
            } else {
              setPreviewUrl(editObj?.filePathSml); //縮圖
            }
            setFileInfo({
              type: editObj?.fileExtension,
              name: `${editObj?.fileName}.${editObj?.fileExtension}`,
            });
          }
          result?.map((item) => {
            if (item?.typeSeq === typeSeq) {
              if (item?.type === "P") {
                //排放源形式=製程排放源時篩選顯示"焊"相關 V1.0 2024/08/01
                axios_queryClassProcessListByType();
              }
              setValue("typeSeq", item);
              setValue("processCode", editObj?.processCode); //v0.75
              axios_querySubTypeDeviceList({
                //設備過濾 類一移動燃燒源 type=== T
                companySeq: itemObj?.companySeq,
                subType: getValues("subType")?.subType,
                type: item?.type,
              });
              axios_queryTypeSubTypeSourceList({
                type: item?.type,
                subType: getValues("subType")?.subType,
              });
              setValue("deviceCode", editObj?.deviceCode, { shouldValidate: true });
              setValue("sourceSeq", editObj?.sourceSeq, { shouldValidate: true });
              setValue("sourceName", editObj?.sourceName, { shouldValidate: true });
              if ((classNo === "4" || classNo === "5" || classNo === "6" || classNo === "103") && editObj?.customRateType !== null) {
                //類四、五、六、103 自定義係數
              } else if ((classNo === "4" || classNo === "5" || classNo === "6" || classNo === "103") && editObj?.customRateType === null) {
                //類四、五、六、103 碳係數
                setValue("cusSourceSeq", editObj?.sourceSeq, { shouldValidate: true });
              }
            }
            if (item?.subTypeList !== null && item?.typeSeq !== typeSeq) {
              item?.subTypeList?.map((subItem) => {
                if (subItem?.typeSeq === typeSeq) {
                  setValue("subType", subItem, { shouldValidate: true });
                  setValue("typeSeq", item, { shouldValidate: true });
                  setValue("processCode", editObj?.processCode, { shouldValidate: true }); //v0.75

                  axios_querySubTypeDeviceList({
                    companySeq: itemObj?.companySeq,
                    subType: subItem?.subType,
                  });
                  axios_queryTypeSubTypeSourceList({
                    type: item?.type,
                    subType: subItem?.subType,
                  });
                  setValue("deviceCode", editObj?.deviceCode, { shouldValidate: true });
                  setValue("sourceSeq", editObj?.sourceSeq, { shouldValidate: true });
                  setValue("sourceName", editObj?.sourceName, { shouldValidate: true });
                  if ((classNo === "4" || classNo === "5" || classNo === "6" || classNo === "103") && editObj?.customRateType !== null) {
                    //類四、五、六、103 自定義係數
                  } else if (
                    (classNo === "4" || classNo === "5" || classNo === "6" || classNo === "103") &&
                    editObj?.customRateType === null
                  ) {
                    //類四、五、六、103 碳係數
                    setValue("cusSourceSeq", editObj?.sourceSeq, { shouldValidate: true });
                  }
                }
              });
            }
          });
        }
      }
    });
  };

  //依排放源查詢該詳細資訊至可編輯表格
  const axios_queryIdentifyDetailList = (sourceSeq) => {
    const classNo = getValues("classSeq")?.classNo;
    let reqBody = {
      deviceCode: getValues("deviceCode")?.length ? getValues("deviceCode") : undefined,
      sourceSeq: sourceSeq,
      gwpVersion: gwpVersion,
    };
    // sourceType 由「是否為碳足跡係數模式」決定
    // - C: classNo=1/2/3 -> 0
    // - C: classNo>3 -> 1
    // - G: classNo=103 需依 typeSeq 映射決定是否等同 C classNo>3
    reqBody.sourceType = isCarbonCoefficientMode ? "1" : "0";

    // console.log("change IdentifyDetailList", getValues(), reqBody, sourceSeq);

    queryIdentifyDetailList(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        const list = res?.data?.RespBody?.identifyDetailList || [];
        setIdentifyDetailList(list);
        // 非七大氣體不列入計算
        const gasCodeList = list.map((item) => item.gasCode);
        if (isSevenMajorGreenhouseGas(gasCodeList) || isSevenMajorGreenhouseGas([getValues("sourceName")])) {
          setValue("isCalculate", true, { shouldValidate: true });
        } else {
          setValue("isCalculate", false, { shouldValidate: true });
        }
        setValue("identifyDetailList", list, { shouldValidate: true });
      }
    });
  };

  // 判斷七大氣體
  const isSevenMajorGreenhouseGas = (gasList) => {
    return gasList.filter(Boolean).some((gas) => {
      return (
        gas.startsWith("CO2") ||
        gas.startsWith("CH4") ||
        gas.startsWith("N2O") ||
        gas.includes("HFC") ||
        gas.includes("PFC") ||
        gas.includes("HFO") ||
        gas.startsWith("SF6") ||
        gas.startsWith("NF3")
      );
    });
  };

  //設備查詢
  const axios_querySubTypeDeviceList = (reqBody) => {
    reqBody.classNo = getValues("classSeq")?.classNo;
    querySubTypeDeviceList(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        setDeviceList(res?.data?.RespBody?.deviceList);
      }
    });
  };
  //排放源查詢
  const axios_queryTypeSubTypeSourceList = (reqBody) => {
    queryTypeSubTypeSourceList(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        setSourceList(res?.data?.RespBody?.sourceList);
      }
    });
  };

  //新增設備
  const axios_CreateSubTypeDevice = () => {
    if (getValues("newEqu") === "") {
      AlertService.ok("", t("validation.required"));
      return;
    }
    CreateSubTypeDevice({
      subType: getValues("subType") === "" ? "O" : getValues("subType")?.subType,
      deviceName: getValues("newEqu"),
      companySeq: itemObj?.companySeq,
      classNo: getValues("classSeq")?.classNo,
    }).then((res) => {
      if (checkDpSuccess(res)) {
        setValue("deviceCode", res?.data?.RespBody?.deviceCode, { shouldValidate: true });
        clearErrors(["deviceCode"]);
        setChecked(false);
        handleSuccessMessage(dispatch, t("button.add") + " " + t("message.success"));
        setValue("newEqu", "");
        axios_querySubTypeDeviceList({
          companySeq: itemObj?.companySeq,
          subType: getValues("subType")?.subType,
        });
      }
    });
  };

  const handleFileChange = (e, pic) => {
    //每次開啟選擇檔案觸發onChange事件
    let imgSize = pic === "devicePic" ? 5000000 : 20000000;
    if (e.target.files[0]) {
      let fileExtension = splitFileExtension(e.target.files[0]?.name);
      if (e.target.files[0].size >= imgSize) {
        //大於5M 或 20MB
        AlertService.ok("Error", `Size over ${imgSize / 1000000}MB`);
        if (pic === "devicePic") {
          setPreviewUrl(null);
          setZoomSrc(null);
          setValue("fileExtension", ""); //副檔名
          setValue("fileName", ""); //檔名
          setValue("devicePic", "");
          setFileInfo({});
          fileInputRef.current.value = null;
        } else if (pic === "customFile") {
          setPreviewCusUrl(null);
          setZoomCusSrc(null);
          setValue("customFileExtension", ""); //副檔名
          setValue("customFileName", ""); //檔名
          setValue("customFile", "");
          setCusFileInfo({});
          customFileInputRef.current.value = null;
        }
      } else {
        if (pic === "devicePic") {
          setPreviewUrl(URL.createObjectURL(e.target.files[0]));
          setZoomSrc(URL.createObjectURL(e.target.files[0]));
          setValue("fileExtension", fileExtension); //副檔名
          setValue("fileName", splitFileName(e.target.files[0]?.name));
          setFileInfo(e.target.files[0]);
          setValue("devicePic", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
        } else if (pic === "customFile") {
          setPreviewCusUrl(URL.createObjectURL(e.target.files[0]));
          setZoomCusSrc(URL.createObjectURL(e.target.files[0]));
          setValue("customFileExtension", fileExtension); //副檔名
          setValue("customFileName", splitFileName(e.target.files[0]?.name));
          setCusFileInfo({
            type: fileExtension,
            name: splitFileName(e.target.files[0]?.name),
          });
          setValue("customFile", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
        }
      }
    }
  };

  const handleDeleteImg = (pic) => {
    //刪除圖片
    if (pic === "devicePic") {
      if (fileInputRef?.current?.value !== undefined) {
        fileInputRef.current.value = null;
        setPreviewUrl(null);
        setZoomSrc(null);
        setValue("fileExtension", ""); //副檔名
        setValue("fileName", ""); //檔名
        setValue("devicePic", "", { shouldValidate: true });
        setFileInfo({});
      }
    } else if (pic === "customFile") {
      if (customFileInputRef?.current?.value !== undefined) {
        customFileInputRef.current.value = null;
        if (customFileInputRef.current) {
          const dataTransfer = new DataTransfer(); // 創建一個空的 FileList
          customFileInputRef.current.files = dataTransfer.files; // 設置為空的 FileList
        }
        setPreviewCusUrl(null);
        setZoomCusSrc(null);
        setValue("customFileExtension", ""); //副檔名
        setValue("customFileName", ""); //檔名
        setValue("customFile", "", { shouldValidate: true });
        setCusFileInfo({});
      }
    }
  };

  const onSubmit = (data) => {
    // console.log(data);
  };

  useEffect(() => {
    let reqBody = {
      class: getClassCodeByCriterion(),
    };
    axios_queryClassProcessList(reqBody);
    axios_getDropdownData(); //v0.75 原燃物料/產品下拉清單
    axios_queryMaterialList(); // v0.75 原燃物料代碼
    axios_getCreateSubTypeBefore(); //建立設備 統一檢核
    axios_getCreateBefore(); //建立 統一檢核
  }, []);

  const onCellEditComplete = (e) => {
    const { rowData, field, originalEvent } = e;

    // 異動說明：修正數值處理邏輯以支援 FormNumberInput
    // 原本：const newValue = parseFloat(e.newValue) ? `${parseFloat(e.newValue)}` : e.value;
    // 現在：直接使用 e.newValue，並確保數值格式正確
    let newValue = e.newValue;

    // 使用 NumberUtil 的標準格式轉換函數
    if (typeof newValue === "string") {
      newValue = NumberUtil.toStandardFormat(newValue);
    }

    // 確保 newValue 是有效的數字字串
    newValue = parseFloat(newValue) ? `${parseFloat(newValue)}` : newValue;

    // console.log(e, newValue);

    if (field === "heatingValue" && e.rowIndex === 0) {
      // 同步更新所有 heatingValue 並重新計算 gasRate
      const updated = identifyDetailList.map((row) => {
        const heatingValue = parseFloat(newValue) || 0;
        const emissionFactorKgPerTJ = parseFloat(row.emissionFactorKgPerTJ) || 0;
        const gasRate = heatingValue * emissionFactorKgPerTJ * (4186.8 * Math.pow(10, -9) * Math.pow(10, -3));

        return {
          ...row,
          heatingValue: newValue,
          gasRate: gasRate > 0 ? gasRate.toFixed(10) : "",
        };
      });
      setIdentifyDetailList(updated);
      setValue("identifyDetailList", updated, { shouldValidate: true });
    } else if (field === "emissionFactorKgPerTJ") {
      // 更新 emissionFactorKgPerTJ 並重新計算 gasRate
      const updated = identifyDetailList.map((row) => {
        if (row === rowData) {
          const heatingValue = parseFloat(row.heatingValue) || 0;
          const emissionFactorKgPerTJ = parseFloat(newValue) || 0;
          const gasRate = heatingValue * emissionFactorKgPerTJ * (4186.8 * Math.pow(10, -9) * Math.pow(10, -3));

          return {
            ...row,
            [field]: newValue,
            gasRate: gasRate > 0 ? gasRate.toFixed(6) : "",
          };
        }
        return row;
      });
      setIdentifyDetailList(updated);
      setValue("identifyDetailList", updated, { shouldValidate: true });
    } else {
      const updated = identifyDetailList.map((row) => (row === rowData ? { ...row, [field]: newValue } : row));
      setIdentifyDetailList(updated);
      setValue("identifyDetailList", updated, { shouldValidate: true });
    }
  };

  // 新增：格式化數值顯示的函數，使用 NumberUtil.formatWithCommas
  // 異動說明：解決越南語系下數值顯示仍為點(.)的問題
  // 原本：直接顯示原始數值
  // 現在：使用 NumberUtil.formatWithCommas 處理數值格式
  const formatNumberDisplay = (value, unit = "") => {
    if (value == null || value === "") return unit ? ` ${unit}` : "";

    // 使用 NumberUtil.formatWithCommas 處理數值格式
    const formattedValue = NumberUtil.formatWithCommas(value);

    // 如果有單位，加上單位
    if (unit) {
      return `${formattedValue} ${unit}`;
    }

    return formattedValue;
  };

  // 編輯元件渲染函數
  // 異動說明：將原本的 InputText 替換為 FormNumberInput 以支援國際化數字格式
  // - 越南語系：使用逗號(,)作為小數點
  // - 其他語系：使用點(.)作為小數點
  // - 自動處理小數點格式轉換
  // - 保持原有的樣式和行為
  const textEditor = (options, isIncludeNegative = false) => {
    const handleChange = (value) => {
      let updatedList;
      const field = options.field;
      const formulaValue = 4186.8 * Math.pow(10, -9) * Math.pow(10, -3);

      if (field === "heatingValue") {
        updatedList = identifyDetailList.map((item) => {
          const heatingValue = value || 0;
          const emissionFactorKgPerTJ = item.emissionFactorKgPerTJ || 0;
          const gasRate = Number(heatingValue * emissionFactorKgPerTJ * formulaValue).toFixed(10);
          return {
            ...item,
            heatingValue: value,
            gasRate: gasRate,
          };
        });
      } else if (field === "emissionFactorKgPerTJ") {
        updatedList = [...identifyDetailList];
        const row = updatedList[options.rowIndex];
        const heatingValue = row.heatingValue || 0;
        const emissionFactorKgPerTJ = value || 0;
        const gasRate = Number(heatingValue * emissionFactorKgPerTJ * formulaValue).toFixed(10);
        updatedList[options.rowIndex] = {
          ...row,
          emissionFactorKgPerTJ: value,
          gasRate: gasRate,
        };
      } else {
        // 只更新單筆 row
        updatedList = [...identifyDetailList];
        updatedList[options.rowIndex] = {
          ...updatedList[options.rowIndex],
          [field]: value,
        };
      }

      // 更新 state
      setIdentifyDetailList(updatedList);
      setValue("identifyDetailList", updatedList, { shouldValidate: true });

      // 通知 DataTable 更新欄位值（可選）
      options.editorCallback(value);
    };

    return (
      <FormNumberInput
        value={options.value}
        className="text-right"
        onChange={handleChange}
        isIncludeNegative={isIncludeNegative}
      />
    );
  };

  const nonEditableCell = (data, field, displayText) => {
    const content = displayText !== undefined && displayText !== null ? displayText : data.value;

    if (!field)
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "#ddd",
            padding: "0.5rem",
            boxSizing: "border-box",
          }}
        >
          {content}
        </div>
      );

    // 異動說明：修正反灰欄位的顯示邏輯
    // 原本：所有欄位都使用 formatNumberDisplay
    // 現在：根據欄位類型選擇合適的顯示方式
    let displayValue;

    // 檢查是否為數值欄位
    const numericFields = [
      "emissionFactorKgPerTJ",
      "heatingValue",
      "gasRate",
      "carbonRate",
      "otherRate1",
      "otherRate2",
      "otherRate3",
      "otherRate4",
      "gasRateUpper",
      "gasRateLower",
    ];

    if (numericFields.includes(field)) {
      // 數值欄位：使用 formatNumberDisplay 格式化
      displayValue = formatNumberDisplay(data[field]);
    } else {
      // 文字欄位：直接顯示原始值
      displayValue = data[field] || "";
    }

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          background: "#ddd",
          padding: "0.5rem",
          boxSizing: "border-box",
        }}
      >
        {displayValue}
      </div>
    );
  };

  //建立前查詢form 規則
  const axios_getCreateSubTypeBefore = () => {
    F1010328Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule],
  );

  useEffect(() => {
    if (actionStatus === "edit" || actionStatus === "copy" || actionStatus === "detail") {
      triggerClassSeqChange(editObj?.classNo, editObj?.typeSeq, true);

      setIdentifyDetailList(getValues("identifyDetailList")); // 設定排放源鑑編輯表格的值
    } else if (actionStatus === "add") {
      setIdentifyDetailList([]); // 清空排放源鑑編輯表格的值
    }
  }, [actionStatus]);

  const triggerClassSeqChange = (classNo, typeSeq) => {
    axios_queryClassNoTypeList(classNo, typeSeq);
  };

  const triggerSourceSeqChange = (sourceSeq) => {
    if (!sourceSeq || sourceSeq === "") return;
    // if (actionStatus !== 'add') return;
    axios_queryIdentifyDetailList(sourceSeq);
  };

  const handleClassSeqChange = (classNo) => {
    setValue("typeSeq", "");
    setValue("subType", "");
    setValue("deviceCode", "");
    setValue("sourceSeq", "");
    setValue("sourceName", ""); // 清空排放源名稱
    setValue("cusSourceSeq", ""); // 清空類四排放源
    // 清空類四自定義相關欄位
    setValue("isCusCoefficent", false);
    setValue("customRate1", "");
    setValue("customRateType", "");
    setValue("customRateSource", "");
    setValue("customEmission", "");
    setValue("customDesc", "");
    setValue("customFile", "");
    setValue("customFileName", "");
    setValue("customFileExtension", "");
    setValue("placeDeviceSeq", "");
    setValue("dept", "");
    setValue("location", "");
    setValue("identifyDetailList", []); // 清空排放源鑑別清單
    setIdentifyDetailList([]); // 清空排放源鑑別清單狀態
    // 清空相關狀態
    setShowEmissionSourceDialog(false); // 關閉排放源選擇開窗
    setShowIndex(false); // 關閉碳足跡係數開窗
    // 清空自定義檔案相關狀態
    setPreviewCusUrl(null);
    setZoomCusSrc(null);
    setCusFileInfo({});
    handleDeleteImg("customFile");
    // 清空排放源清單 - 因為不同類別的係數會不同
    setSourceList([]);

    axios_queryClassNoTypeList(classNo);
  };

  return (
    <>
      <form className="grid" onSubmit={handleSubmit(onSubmit)}>
        {/* 場所 */}
        <div className="col-12">
          <label htmlFor="planPlaceSeq" className="form-label required">
            {t("place")}
          </label>
          <Controller
            name="planPlaceSeq"
            control={control}
            rules={setValidFormCreate("planPlaceSeq")}
            render={({ field, fieldState }) => (
              <Dropdown
                showClear
                appendTo={"self"}
                optionLabel="placeName"
                optionValue="planPlaceSeq"
                disabled={disabledCondition}
                value={field.value ?? ""}
                options={companyPlaceList}
                placeholder={t("plz_chs")}
                className={`w-full mr-2 ` + classNames({ "p-invalid": fieldState.error })}
                onChange={(e) => {
                  field.onChange(e.value);
                  if (e.value === undefined) {
                    setValue("planPlaceSeq", "", { shouldValidate: true });
                  }
                  // 切換場所時清空設備編號（新場所下原選設備可能不存在）
                  setValue("placeDeviceSeq", undefined);
                }}
              />
            )}
          />
          {getFormErrorMessage(errors, "planPlaceSeq")}
        </div>
        {/* 範疇/類別 */}
        <div className="col-12">
          <label htmlFor="classSeq" className="form-label required">
            {t("category")}
          </label>
          <Controller
            name="classSeq"
            control={control}
            rules={setValidFormCreate("classSeq")}
            render={({ field, fieldState }) => (
              <Dropdown
                appendTo={"self"}
                optionLabel="className"
                disabled={disabledCondition}
                value={field.value}
                virtualScrollerOptions={{ itemSize: 40 }}
                defaultValue={""}
                placeholder={t("plz_chs")}
                name="classSeq"
                control={control}
                options={classList}
                className={`w-full mr-2 ` + classNames({ "p-invalid": fieldState.error })}
                onChange={(event) => {
                  field.onChange(event.value);
                  handleClassSeqChange(event.value?.classNo);
                }}
              />
            )}
          />
        </div>
        {/* 排放源型式 */}
        <div className={`col-12 ${getValues("typeSeq")?.subTypeList?.length > 0 ? "lg:col-6" : "lg:col-12"}`}>
          <label htmlFor="typeSeq" className="form-label required">
            {t("emission_source_type")}
          </label>
          <Controller
            name="typeSeq"
            control={control}
            rules={setValidFormCreate("typeSeq")}
            render={({ field, fieldState }) => (
              <Dropdown
                appendTo={"self"}
                optionLabel="typeName"
                disabled={disabledCondition}
                value={field.value}
                virtualScrollerOptions={{ itemSize: 40 }}
                defaultValue={""}
                placeholder={t("plz_chs")}
                name="typeSeq"
                control={control}
                options={typeList}
                className={`w-full mr-2` + classNames({ "p-invalid": fieldState.error })}
                onChange={(event) => {
                  //製程排放源 排放源形式=製程排放源時篩選顯示"焊"相關 丟入type參數
                  axios_queryClassProcessListByType({ type: event?.value?.type });
                  // 不同排放源型式會有不同的製程 設備 排放源 產品 需清空值
                  setValue("processCode", "");
                  setValue("sourceSeq", "");
                  setValue("sourceName", "");
                  setValue("cusSourceSeq", ""); //類四
                  setValue("isCusCoefficent", false);
                  setValue("materialCode", "");
                  setValue("placeDeviceSeq", "");
                  setValue("dept", "");
                  setValue("location", "");
                  setValue("identifyDetailList", []); // 清空排放源鑑別範疇/類別
                  setIdentifyDetailList([]); // 清空排放源
                  // 清空相關狀態
                  setShowEmissionSourceDialog(false); // 關閉排放源選擇開窗
                  setShowIndex(false); // 關閉碳足跡係數開窗

                  // 清空自定義檔案相關狀態
                  setPreviewCusUrl(null);
                  setZoomCusSrc(null);
                  setCusFileInfo({});
                  handleDeleteImg("customFile");
                  // 清空排放源清單 - 因為不同排放源型式會有不同的排放源
                  setSourceList([]);

                  if (event?.value?.type === "GP") {
                    //綠電預設不列入計算
                    setValue("isCalculate", false);
                  } else {
                    setValue("isCalculate", true);
                  }

                  if (event?.value?.type === "CHP") {
                    //排放源形式=汽電共生時預設勾選
                    setValue("isCHP", true);
                  } else {
                    setValue("isCHP", false);
                  }

                  field.onChange(event.value);
                  setValue("subType", "");
                  setValue("deviceCode", "");
                  axios_querySubTypeDeviceList({
                    companySeq: itemObj?.companySeq,
                    subType: getValues("subType")?.subType,
                    type: event?.value?.type, //類一移動燃燒源 設備選單內容篩選
                  });
                  axios_queryTypeSubTypeSourceList({
                    type: event.value?.type,
                    subType: getValues("subType")?.subType,
                  });
                }}
              />
            )}
          />
        </div>
        {/* 排放源Sub型式 如果 typeSeq 的 subTypeList 有值才出現 */}
        {getValues("typeSeq")?.subTypeList && (
          <div className="col-12 lg:col-6">
            <label htmlFor="subType" className="form-label required">
              {t("type")}
            </label>
            <Controller
              name="subType"
              control={control}
              rules={{
                required: {
                  value: getValues("typeSeq")?.subTypeList?.length > 0 ? true : false,
                  message: t("validation.required"),
                },
              }}
              render={({ field, fieldState }) => (
                <Dropdown
                  appendTo={"self"}
                  optionLabel="typeName"
                  disabled={disabledCondition}
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name={t("type")}
                  control={control}
                  options={getValues("typeSeq")?.subTypeList}
                  className={`w-full mr-2` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                    setValue("deviceCode", "");
                    setValue("sourceSeq", "");
                    setValue("sourceName", "");
                    setValue("cusSourceSeq", ""); //類四
                    setValue("placeDeviceSeq", "");
                    setValue("dept", "");
                    setValue("location", "");
                    setValue("isCusCoefficent", false);
                    setValue("identifyDetailList", []); // 清空排放源鑑別範疇/類別
                    setIdentifyDetailList([]); // 清空排放源
                    // 清空相關狀態
                    setShowEmissionSourceDialog(false); // 關閉排放源選擇開窗
                    setShowIndex(false); // 關閉碳足跡係數開窗

                    // 清空自定義檔案相關狀態
                    setPreviewCusUrl(null);
                    setZoomCusSrc(null);
                    setCusFileInfo({});
                    handleDeleteImg("customFile");
                    // 清空排放源清單 - 因為不同排放源Sub型式會有不同的排放源
                    setSourceList([]);

                    axios_querySubTypeDeviceList({
                      companySeq: itemObj?.companySeq,
                      subType: event.value?.subType,
                      type: getValues("typeSeq")?.type, //類一移動燃燒源 設備選單內容篩選
                    });
                    //也要一併更新 排放源查詢清單
                    axios_queryTypeSubTypeSourceList({
                      type: getValues("typeSeq")?.type,
                      subType: event.value?.subType,
                    });
                  }}
                />
              )}
            />
          </div>
        )}
        {/* 納管行業別、納管條件：僅在非通用行業且非製造業時顯示 */}
        {showRegulatedFields && (
          <>
            {/* 設備編號（依所選場所篩選 placeDeviceList.placeSeq） */}
            <div className="col-6">
              <label htmlFor="placeDeviceSeq" className="form-label">
                {t("placeDeviceNo")}
              </label>
              <Controller
                name={`placeDeviceSeq`}
                rules={setValidFormCreate("placeDeviceSeq")}
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    showClear
                    optionLabel="displayLabel"
                    optionValue="placeDeviceSeq"
                    disabled={disabledCondition}
                    value={field.value}
                    options={filteredPlaceDeviceList}
                    placeholder={selectedPlanPlaceSeq ? t("plz_chs") : t("place_plz_select_first")}
                    className={`w-full mr-2` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(e) => {
                      field.onChange(e.value);
                      if (e.value === undefined) {
                        setValue("placeDeviceSeq", "", { shouldValidate: true });
                        return;
                      }
                      const device = deviceMap.get(e.value);
                      const place = placeMap.get(device?.placeSeq);
                      setValue("planPlaceSeq", place?.planPlaceSeq);
                      setValue("dept", device?.dept ?? "");
                      setValue("location", device?.location ?? "");
                      if (!device) return;
                      // 依設備帶入：類別、排放源形式、設備/服務、原燃物料
                      const classObj = classList?.find((c) => c.classNo == device.classNo);
                      if (classObj) {
                        setValue("classSeq", classObj);
                        queryClassNoTypeList({ classNo: device.classNo }).then((res) => {
                          if (!checkDpSuccess(res)) return;
                          const typeListData = res.data.RespBody?.typeList ?? [];
                          setTypeList(typeListData);
                          let foundItem = null;
                          let foundSubItem = null;
                          for (const item of typeListData) {
                            if (item?.typeSeq == device.typeSeq) {
                              foundItem = item;
                              break;
                            }
                            if (item?.subTypeList?.length) {
                              for (const subItem of item.subTypeList) {
                                if (subItem?.typeSeq == device.typeSeq) {
                                  foundItem = item;
                                  foundSubItem = subItem;
                                  break;
                                }
                              }
                              if (foundItem) break;
                            }
                          }
                          if (foundItem) {
                            setValue("typeSeq", foundItem);
                            if (foundSubItem) setValue("subType", foundSubItem);
                            if (foundItem?.type === "P") axios_queryClassProcessListByType();
                            axios_querySubTypeDeviceList({
                              companySeq: itemObj?.companySeq,
                              subType: foundSubItem?.subType,
                              type: foundItem?.type,
                            });
                            axios_queryTypeSubTypeSourceList({
                              type: foundItem?.type,
                              subType: foundSubItem?.subType,
                            });
                          }
                          setValue("deviceCode", device.deviceCode ?? "", { shouldValidate: true });
                          if (device.materialType != null && device.materialType !== "")
                            setValue("materialType", device.materialType);
                          if (device.materialCode != null && device.materialCode !== "")
                            setValue("materialCode", device.materialCode ?? "");
                        });
                      } else {
                        setValue("deviceCode", device.deviceCode ?? "", { shouldValidate: true });
                        if (device.materialType != null && device.materialType !== "")
                          setValue("materialType", device.materialType);
                        if (device.materialCode != null && device.materialCode !== "")
                          setValue("materialCode", device.materialCode ?? "");
                      }
                    }}
                  />
                )}
              />
            </div>
            {/* 數量 */}
            <div className="col-6">
              <FormNumberInput
                wrapperClass="w-full"
                withLabel={true}
                register={register}
                errors={errors}
                id="quantity"
                name="quantity"
                labelText={t("quantity")}
                step="any"
                value={watch("quantity")}
                disabled={disabledCondition}
                onChange={(newValue) => setValue("quantity", newValue)}
              />
            </div>
            {/* 設備所屬單位/部門 */}
            <div className="col-6">
              <FormTextarea
                register={register}
                errors={errors}
                id={`dept`}
                name={`dept`}
                disabled={disabledCondition}
                rules={setValidForm("dept")}
                labelText={t("dept")}
                areaClass="w-full"
              />
            </div>
            {/* 設備位置/樓層 */}
            <div className="col-6">
              <FormTextarea
                register={register}
                errors={errors}
                id={`location`}
                name={`location`}
                disabled={disabledCondition}
                rules={setValidForm("location")}
                labelText={t("location")}
                areaClass="w-full"
              />
            </div>
          </>
        )}

        {/* 製程 類2、102 隱藏 */}
        {getValues("classSeq")?.classNo === "2" || getValues("classSeq")?.classNo === "102" ? (
          <></>
        ) : (
          <div
            className={`col-12 sm:col-${isCarbonCoefficientMode || getValues("typeSeq")?.type === "P" ? "12" : "6"}`}
          >
            <label htmlFor="processCode" className="form-label">
              {t("manufacturing_process")}
            </label>
            <Controller
              name="processCode"
              control={control}
              rules={{ required: { value: false, message: t("validation.required") } }}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  disabled={disabledCondition}
                  // virtualScroller
                  virtualScrollerOptions={{ itemSize: 40 }}
                  showClear={field.value}
                  appendTo={"self"}
                  optionLabel="processName"
                  optionValue="processCode"
                  value={field.value}
                  placeholder={t("plz_chs")}
                  options={processList}
                  className={`w-full mr-2` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
          </div>
        )}
        {/* 設備 類2、102 隱藏 / 排放源形式=製程排放源時隱藏 */}
        {getValues("classSeq")?.classNo === "2" ||
        getValues("classSeq")?.classNo === "102" ||
        getValues("typeSeq")?.type === "P" ||
        isCarbonCoefficientMode ? (
          <></>
        ) : (
          <div className="col-12 sm:col-6">
            <label htmlFor="deviceCode" className="form-label">
              {t("equipment")}
            </label>
            <div className="flex gap-2 align-items-center flex-wrap lg:flex-nowrap">
              <div className="flex gap-2 align-items-center">
                <Checkbox
                  disabled={disabledCondition}
                  inputId="add"
                  onChange={(e) => {
                    setChecked(e.checked);
                    if (e.checked === true) {
                      setValue("deviceCode", "", { shouldValidate: true });
                    } else {
                      clearErrors(["newEqu"]);
                    }
                  }}
                  checked={addChecked}
                ></Checkbox>
                {/* className='white-space-nowrap' */}
                <label htmlFor="add" className="white-space-nowrap">
                  {t("button.add")}
                </label>
              </div>
              <div className="col-additem-checkbox-input">
                {addChecked ? (
                  <div className="flex gap-2 align-items-center flex-nowrap">
                    <FormInput
                      rules={
                        addChecked === true
                          ? setValidForm("deviceName")
                          : { required: { value: false, message: t("validation.required") } }
                      }
                      disabled={disabledCondition}
                      register={register}
                      errors={errors}
                      id="newEqu"
                      name="newEqu"
                      type="text"
                      enterClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <Button
                      disabled={disabledCondition}
                      onClick={(e) => {
                        e.preventDefault();
                        axios_CreateSubTypeDevice();
                      }}
                      label={t("button.add")}
                      size="small"
                      className="white-space-nowrap"
                    ></Button>
                  </div>
                ) : (
                  <Controller
                    name="deviceCode"
                    control={control}
                    rules={setValidFormCreate("deviceCode")}
                    render={({ field, fieldState }) => (
                      <div>
                        <Dropdown
                          // panelFooterTemplate={panelFooterTypeTemplate}
                          showClear={field.value}
                          disabled={disabledCondition}
                          appendTo={"self"}
                          optionLabel="deviceName"
                          optionValue="deviceCode"
                          value={field.value}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="deviceCode"
                          control={control}
                          filter
                          options={deviceList}
                          className={`w-full flex-shrink-1 ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                            setValue("sourceSeq", "");
                            setValue("sourceName", "");
                            setValue("cusSourceSeq", ""); //類四
                            setValue("isCusCoefficent", false);
                            setValue("identifyDetailList", []); // 清空排放源鑑別範疇/類別
                            setIdentifyDetailList([]); // 清空排放源
                            setValue("isCalculate", true); // 預設計算
                            setValue("materialCode", ""); // 清空原燃物料代碼
                          }}
                        />
                        <label>{getFormErrorMessage(errors, "deviceCode")}</label>
                      </div>
                    )}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {/* 排放源：碳足跡係數 / 自定義係數區塊（G 模式下由 typeSeq 映射控制） */}
        {isCarbonCoefficientMode ? (
          <div className="col-12">
            <div className="flex flex-wrap">
              <label className="form-label required mr-3">{t("carbonFootCoef")}</label>
              <Controller
                name="isCusCoefficent"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <Checkbox
                      inputId={field.name}
                      disabled={disabledCondition}
                      checked={field.value}
                      inputRef={field.ref}
                      className={classNames({ "p-invalid": fieldState.error })}
                      onChange={(e) => {
                        field.onChange(e.checked);
                        clearErrors(["customFile", "customRateSource", "customDesc", "customRateType"]);
                        if (e.checked) {
                          if (
                            getValues("customRateType") === "" ||
                            getValues("customRateType") === undefined ||
                            getValues("customRateType") === null
                          ) {
                            setValue("customRateType", "5");
                          }
                        } else {
                          trigger("cusSourceSeq");
                        }
                      }}
                    />
                    <label htmlFor={field.name} className="ml-2">
                      {t("cusCoefficent")}
                    </label>
                  </>
                )}
              />
            </div>
            <div style={{ display: "none" }}>
              <FormInput
                register={register}
                errors={errors}
                id="cusSourceSeq"
                name="cusSourceSeq"
                type="text"
                disabled={true}
                rules={{
                  required: {
                    value: isCarbonCoefficientMode && isCusCoefficentValue === false ? true : false,
                    message: t("validation.required"),
                  },
                }}
              />
            </div>
            <div className="mb-3">
              <FormInputSearch
                register={register}
                errors={errors}
                id="sourceName"
                name="sourceName"
                type="text"
                // disabled={true}
                readOnly={true}
                btnSerch={btnSerchSourceName}
                disabled={disabledCondition}
              />
            </div>

            <div
              style={{
                display: isCusCoefficentValue && isCarbonCoefficientMode ? "block" : "none",
              }}
            >
              <PrimePanel header={t("cusCoefficent")} toggleable>
                {/* 自定義係數畫面 類四用 擴展到 4、5、6*/}
                <div className="grid">
                  <div className="col-6 flex">
                    <FormNumberInput
                      wrapperClass="w-full"
                      withLabel={true}
                      register={register}
                      errors={errors}
                      id="customRate1"
                      name="customRate1"
                      labelText={t("customRate")}
                      step="any"
                      value={watch("customRate1")}
                      disabled={disabledCondition}
                      onChange={(newValue) => setValue("customRate1", newValue)}
                    />
                    <div className="form-label-has-top-space">
                      <label htmlFor="customRate1">kgCO₂e</label>
                    </div>
                  </div>
                  <div className="col-6 lg:col-6">
                    <label htmlFor="customRateType" className="form-label required">
                      {t("rateType")}
                    </label>
                    <Controller
                      name="customRateType"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          filter
                          optionLabel="subitemName"
                          disabled={disabledCondition}
                          optionValue="subitemNo"
                          value={field.value}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="customRateType"
                          control={control}
                          options={rateTypeList}
                          className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-12">
                    <FormInput
                      labelClass="required"
                      withLabel={false}
                      register={register}
                      errors={errors}
                      id="customRateSource"
                      name="customRateSource"
                      placeholder={t("validation.limitMaxChar", { max: 50 })}
                      labelText={t("customRateSource")}
                      type="text"
                      disabled={disabledCondition}
                      rules={{
                        required: {
                          value: isCusCoefficentValue && isCarbonCoefficientMode ? true : false,
                          message: t("validation.required"),
                        },
                      }}
                    />
                  </div>

                  {/* Not needed temporarily  */}
                  {/* <div className="col-12 lg:col-6 flex">
                                    <FormInput
                                        wrapperClass='w-full'
                                        withLabel={true}
                                        register={register}
                                        errors={errors}
                                        id="customEmission"
                                        name="customEmission"
                                        labelText={t('changeEmission')}
                                        type="number"
                                        step="any"
                                    />
                                    <div className="form-label-has-top-space">
                                        <label htmlFor="customEmission">tCO2e</label>
                                    </div>
                                </div> */}
                  <div className="col-12">
                    <FormTextarea
                      register={register}
                      errors={errors}
                      id="customDesc"
                      name="customDesc"
                      type="text"
                      labelText={t("changeEmissionDesc")}
                      labelClass="required"
                      areaClass="w-full"
                      disabled={disabledCondition}
                      placeholder={t("validation.limitMaxChar", { max: 1000 })}
                      rules={{
                        required: {
                          value: isCusCoefficentValue && isCarbonCoefficientMode ? true : false,
                          message: t("validation.required"),
                        },
                      }}
                    />
                  </div>
                  {/* 佐證資料檔案 */}
                  <div className="col-12">
                    <label htmlFor="customFile" className="form-label required">
                      {t("supportingInfo")}
                    </label>
                    <div className="grid">
                      <div className={`${previewCusUrl ? "col-6" : "col-12"}`}>
                        <FormInputFile
                          register={register}
                          errors={errors}
                          acceptFileType=".jpg,.png,.pdf,.zip"
                          id="customFile"
                          name="customFile"
                          limitSize="20MB"
                          fileChange={(e) => {
                            handleFileChange(e, "customFile");
                          }}
                          fileInputRef={customFileInputRef}
                          disabled={disabledCondition}
                          rules={{
                            validate: (value) => {
                              if (isCusCoefficentValue && isCarbonCoefficientMode) {
                                return value ? true : t("validation.required");
                              }
                              return true;
                            },
                          }}
                        />
                      </div>
                      {getValues("customFileExtension") && (
                        <div className="col-6">
                          {getValues("customFileExtension") !== "zip" && (
                            <ImagePDFComponent
                              wrapperClass="mt-2"
                              file={CusfileInfo}
                              previewUrl={previewCusUrl}
                              zoomSrc={zoomCusSrc}
                              disabled={disabledCondition}
                              imgWidth="150"
                              imgHeight="150"
                              deleteImg={() => {
                                handleDeleteImg("customFile");
                              }}
                            />
                          )}

                          {watch("customFileExtension") === "zip" && (
                            <div className="flex flex-wrap lg:flex-nowrap align-items-center">
                              <label>
                                {watch("customFileName")}
                                {watch("customFileName") !== "" ? "." : ""}
                                {watch("customFileExtension")}
                              </label>
                              <Button
                                type="button"
                                icon="pi pi-trash"
                                tooltip={t("button.delete")}
                                tooltipOptions={{ position: "top" }}
                                className="p-button-icon-only"
                                rounded
                                text
                                severity="danger"
                                id="delCustomFileBtn"
                                disabled={disabledCondition}
                                onClick={() => {
                                  handleDeleteImg("customFile");
                                }}
                              ></Button>

                              <Button
                                rounded
                                text
                                severity="secondary"
                                className="p-button-icon-only"
                                type="button"
                                tooltip={t("button.download")}
                                tooltipOptions={{ position: "top" }}
                                onClick={() => {
                                  downloadItem(editObj);
                                }}
                              >
                                <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
                              </Button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </PrimePanel>
            </div>
          </div>
        ) : (
          <div className="col-12">
            <label htmlFor="sourceSeq" className="form-label required">
              {t("emission_source")}
            </label>
            <FormInputSearch
              register={register}
              errors={errors}
              id="sourceName"
              name="sourceName"
              type="text"
              readOnly={true}
              btnSerch={btnSerchSourceName}
              disabledBtn={disabledCondition}
              disabled={disabledCondition}
            />

            {/* 隱藏的 sourceSeq 欄位，用於儲存選擇的值 */}
            <input
              type="hidden"
              {...register("sourceSeq", {
                required: {
                  value: !isCarbonCoefficientMode,
                  message: t("validation.required"),
                },
              })}
            />

            {/* 依排放源顯示可編輯表格 */}
            <div className="mt-3">
              <div
                className="flex align-items-center cursor-pointer p-2 border-round surface-100 hover:surface-200"
                onClick={() => setIsIdentifyDetailExpanded(!isIdentifyDetailExpanded)}
                style={{ border: "1px solid #dee2e6" }}
              >
                <i className={`pi ${isIdentifyDetailExpanded ? "pi-chevron-down" : "pi-chevron-right"} mr-2`}></i>
                <span className="font-semibold">{t("emission_source_detail")}</span>
              </div>
              {isIdentifyDetailExpanded && (
                <DataTable
                  stripedRows
                  {...(!disabledCondition && { editMode: "cell" })}
                  className="white-data-table no-shadow mt-2"
                  tableStyle={{ minWidth: "800px" }}
                  value={identifyDetailList}
                  emptyMessage={t("no_rec")}
                  showGridlines
                  rowGroupMode="rowspan"
                  groupRowsBy="heatingValue"
                >
                  <Column
                    style={{ minWidth: "80px" }}
                    field="gasCode"
                    headerClassName="text-center"
                    bodyClassName="text-center"
                    header={t("gasCode")}
                    body={(rowData) => nonEditableCell(rowData, "gasCode")}
                  />
                  <Column
                    style={{ minWidth: "80px" }}
                    field="gwpValue"
                    headerClassName="text-center"
                    bodyClassName="text-right"
                    header={"GWP"}
                    body={(rowData) => {
                      return <div>{`${formatNumberDisplay(rowData.gwpValue)}`}</div>;
                    }}
                    {...(isEditable && {
                      editor: (options) => textEditor(options),
                    })}
                  />
                  {shouldShowEmissionFactorAndHeatingValueColumns() && (
                    <Column
                      style={{ minWidth: "80px" }}
                      field="emissionFactorKgPerTJ"
                      headerClassName="text-center"
                      bodyClassName="text-right"
                      header={t("emissionFactorKgPerTJ")}
                      body={(rowData) => {
                        return (
                          <div>
                            {`${formatNumberDisplay(rowData.emissionFactorKgPerTJ)}`}
                            {rowData.emissionFactorKgPerTJ && rowData.emissionFactorKgPerTJUnit && <br />}
                            {`${rowData.emissionFactorKgPerTJUnit || ""}`}
                          </div>
                        );
                      }}
                      {...(isEditable && {
                        editor: (options) => textEditor(options),
                      })}
                      //   editor={isEditable ? textEditor : nonEditableCell}
                      //   onCellEditComplete={onCellEditComplete}
                    />
                  )}
                  {shouldShowEmissionFactorAndHeatingValueColumns() && (
                    <Column
                      key={"heatingValue"}
                      style={{ minWidth: "80px" }}
                      field="heatingValue"
                      header={t("heatingValue")}
                      headerClassName="text-center"
                      bodyClassName="text-right"
                      body={(rowData, options) =>
                        options.rowIndex === 0 ? (
                          <div>{formatNumberDisplay(rowData.heatingValue)}</div>
                        ) : (
                          nonEditableCell(rowData, "heatingValue")
                        )
                      }
                      {...(isEditable && {
                        editor: (options) => (options.rowIndex === 0 ? textEditor(options) : nonEditableCell(options)),
                      })}
                    />
                  )}
                  <Column
                    style={{ minWidth: "80px" }}
                    field="gasRate"
                    headerClassName="text-center"
                    bodyClassName="text-right"
                    header={getHeaderByContext("gasRate", getCurrentContext())}
                    body={(rowData) => {
                      if (
                        itemObj.planType !== "0" &&
                        itemObj.planType !== "1" &&
                        getValues("classSeq")?.classNo === "1" &&
                        (watch("typeSeq")?.type === "E" || watch("typeSeq")?.type === "T")
                      ) {
                        return nonEditableCell(
                          rowData,
                          "",
                          <>
                            {formatNumberDisplay(rowData.gasRate)}
                            {rowData.gasRate && rowData.gasRateUnit && <br />}
                            {rowData?.gasRateUnit || ""}
                          </>,
                        );
                      } else
                        return (
                          <div>
                            {`${formatNumberDisplay(rowData.gasRate)}`}
                            {rowData.gasRate && rowData.gasRateUnit && <br />}
                            {` ${rowData?.gasRateUnit || ""}`}
                          </div>
                        );
                    }}
                    {...(isEditable &&
                      (itemObj.planType === "0" ||
                        itemObj.planType === "1" ||
                        !(
                          getValues("classSeq")?.classNo === "1" &&
                          (watch("typeSeq")?.type === "E" || watch("typeSeq")?.type === "T")
                        )) && {
                        editor: (options) => textEditor(options),
                      })}
                    // editor={isEditable ? textEditor : nonEditableCell}
                    // onCellEditComplete={onCellEditComplete}
                  />
                  {getOtherRateColumns().map((config, index) => (
                    <Column
                      key={config.field}
                      field={config.field}
                      header={config.header}
                      headerStyle={{ textAlign: "center" }}
                      bodyClassName="text-right"
                      style={{ minWidth: "80px" }}
                      body={(rowData) => {
                        return <div>{formatNumberDisplay(rowData[config.field])}</div>;
                      }}
                      {...(isEditable && {
                        editor: (options) => textEditor(options),
                      })}
                      //   editor={isEditable ? textEditor : nonEditableCell}
                      //   onCellEditComplete={onCellEditComplete}
                    />
                  ))}

                  <Column
                    field="gasRateUpper"
                    header={t("gasRateUpper")}
                    headerStyle={{ textAlign: "center" }}
                    bodyClassName="text-right"
                    style={{ minWidth: "80px" }}
                    body={(rowData) => <div>{formatNumberDisplay(rowData.gasRateUpper)}</div>}
                    {...(isEditable && {
                      editor: (options) => textEditor(options, true),
                    })}
                    // editor={isEditable ? textEditor : nonEditableCell}
                    // onCellEditComplete={onCellEditComplete}
                  />
                  <Column
                    field="gasRateLower"
                    header={t("gasRateLower")}
                    headerStyle={{ textAlign: "center" }}
                    bodyClassName="text-right"
                    style={{ minWidth: "80px" }}
                    body={(rowData) => <div>{formatNumberDisplay(rowData.gasRateLower)}</div>}
                    {...(isEditable && {
                      editor: (options) => textEditor(options, true),
                    })}
                    // editor={isEditable ? textEditor : nonEditableCell}
                    // onCellEditComplete={onCellEditComplete}
                  />
                </DataTable>
              )}
            </div>
          </div>
        )}
        {/* 原燃物料/產品 原燃物料類別 v0.75 */}
        <div className="col-12 lg:col-6">
          <label htmlFor="materialType" className="form-label required">
            {t("material")}
          </label>
          <Controller
            name="materialType"
            control={control}
            rules={setValidFormCreate("materialType")}
            render={({ field, fieldState }) => (
              <Dropdown
                appendTo={"self"}
                optionLabel="subitemName"
                disabled={disabledCondition}
                optionValue="subitemNo"
                value={field.value}
                // virtualScrollerOptions={{ itemSize: 40 }}
                defaultValue={""}
                placeholder={t("plz_chs")}
                name="materialType"
                control={control}
                options={materialTypeList}
                className={`w-full mr-2` + classNames({ "p-invalid": fieldState.error })}
                onChange={(event) => {
                  field.onChange(event.value);
                }}
              />
            )}
          />
        </div>
        {/* v0.75 原燃物料代碼  */}
        <div className="col-12 lg:col-6">
          <label htmlFor="materialCode" className="form-label">
            &nbsp;
          </label>
          <Controller
            name="materialCode"
            control={control}
            rules={setValidFormCreate("materialCode")}
            render={({ field, fieldState }) => (
              <Dropdown
                filter
                showClear
                disabled={disabledCondition}
                optionLabel="materialName"
                optionValue="materialCode"
                value={field.value}
                virtualScrollerOptions={{ itemSize: 40 }}
                defaultValue={""}
                placeholder={t("plz_chs")}
                name="materialCode"
                control={control}
                options={materialCodeList}
                className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                onChange={(event) => {
                  field.onChange(event.value);
                  if (event.value === undefined) {
                    setValue("materialCode", "", { shouldValidate: true });
                  }
                }}
              />
            )}
          />
        </div>
        {/* v0.75 是否屬生質能源 */}
        <div className="col-12 lg:col-6">
          <Controller
            name="isBiomass"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Checkbox
                  inputId={field.name}
                  disabled={disabledCondition}
                  checked={field.value}
                  inputRef={field.ref}
                  className={classNames({ "p-invalid": fieldState.error })}
                  onChange={(e) => {
                    field.onChange(e.checked);
                  }}
                />
                <label htmlFor={field.name} className="ml-2">
                  {t("isBiomass")}
                </label>
                {getFormErrorMessage(errors, field.name)}
              </>
            )}
          />
        </div>
        {/* v0.75 是否屬汽電共生 */}
        <div className="col-12 lg:col-6">
          <Controller
            name="isCHP"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Checkbox
                  inputId={field.name}
                  disabled={disabledCondition}
                  checked={field.value}
                  inputRef={field.ref}
                  className={classNames({ "p-invalid": fieldState.error })}
                  onChange={(e) => {
                    field.onChange(e.checked);
                  }}
                />
                <label htmlFor={field.name} className="ml-2">
                  {t("isCHP")}
                </label>
                {getFormErrorMessage(errors, field.name)}
              </>
            )}
          />
        </div>
        {/* 數量 類2顯示電號 其他不顯示(數量欄位移除) 改用此判斷規則 */}
        {getValues("classSeq")?.classNo === "2" && (
          <div className="col-6">
            <FormInput
              register={register}
              errors={errors}
              id="customerNo"
              name="customerNo"
              type="number"
              disabled={disabledCondition}
              labelText={t("electMeterNo")}
              rules={setValidFormCreate("customerNo")}
            />
          </div>
        )}
        {/* 數量 類2顯示電號 其他顯示數量 註解 之前的判斷規則 */}
        {/* <div className='col-6'>
                {
                    getValues("classSeq")?.classNo === "2" ?( 
                    <FormInput
                        register={register}
                        errors={errors}
                        id="customerNo"
                        name="customerNo"
                        type="number"
                        labelText={t('electMeterNo')}
                        rules={setValidFormCreate("customerNo")}
                    />
                ):(
                        <FormInput
                        register={register}
                        errors={errors}
                        id="quantity"
                        name="quantity"
                        type="number"
                        labelText={t('quantity')}
                        rules={setValidFormCreate("quantity")}
                    />
                    )
                }
               
            </div> */}
        {/* 列入計算 */}
        <div
          className={`${
            getValues("classSeq")?.classNo === "2" ? "col-6 flex align-items-center pt-5" : "col-12 lg:col-6"
          }`}
        >
          {/* <Checkbox inputId="isCalculate" onChange={e => {setCalculate(e.checked);clearErrors("remark")}} checked={isCalculate}></Checkbox>
                <label htmlFor="isCalculate" className='white-space-nowrap ml-2'>{t('is_calculate')}</label> */}
          <Controller
            name="isCalculate"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Checkbox
                  disabled={
                    (watch("classSeq")?.classNo === "2" &&
                      watch("typeSeq")?.type === "GP" &&
                      watch("sourceSeq") === "0_0000005b") ||
                    disabledCondition
                  }
                  inputId={field.name}
                  checked={field.value}
                  inputRef={field.ref}
                  className={classNames({ "p-invalid": fieldState.error })}
                  onChange={(e) => {
                    field.onChange(e.checked);
                    clearErrors("remark");
                  }}
                />
                <label htmlFor={field.name} className="ml-2">
                  {t("is_calculate")}
                </label>
                {getFormErrorMessage(errors, field.name)}
              </>
            )}
          />
        </div>
        {/* 備註 */}
        <div className="col-12">
          <FormTextarea
            register={register}
            errors={errors}
            id="remark"
            name="remark"
            disabled={disabledCondition}
            type="text"
            labelText={t("remark")}
            labelClass={getValues("isCalculate") ? "" : "required"}
            areaClass="w-full"
            placeholder={getValues("isCalculate") ? t("remark_placeholder") : t("not_calculation_placeholder")}
            rules={{
              required: {
                value: getValues("isCalculate") ? false : true,
                message: t("validation.required"),
              },
              maxLength: {
                value: 200,
                message: t("validation.limitMaxChar", { max: 200 }),
              },
            }}
          />
        </div>
        {/* 附圖 */}
        <div className="col-12">
          <label htmlFor="entityBoundary" className="form-label">
            {t("attached_picture")}/{t("attachments")}
          </label>
          <div className="grid">
            <div className={`${previewUrl ? "col-6" : "col-12"}`}>
              <FormInputFile
                register={register}
                errors={errors}
                acceptFileType=".jpg,.png,.pdf"
                id="devicePic"
                name="devicePic"
                disabled={disabledCondition}
                fileChange={(e) => {
                  handleFileChange(e, "devicePic");
                }}
                fileInputRef={fileInputRef}
              />
            </div>
            {previewUrl && (
              <div className="col-6">
                <ImagePDFComponent
                  file={fileInfo}
                  previewUrl={previewUrl}
                  zoomSrc={zoomSrc}
                  disabled={disabledCondition}
                  imgWidth="150"
                  imgHeight="150"
                  deleteImg={() => {
                    handleDeleteImg("devicePic");
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
      <PrimeDialog
        scrollByBody={true}
        visible={showIndex}
        isShowConfBtn={false}
        onClose={() => {
          setShowIndex(false);
          setValue("keywordSearch", "");
        }}
        onConfirm={() => {}}
        title={t("coefficient")}
        size="lg"
        bodyTemplate={
          <CarbonCoefficientComponent
            getValues={getValues}
            register={register}
            errors={errors}
            setPickDialog={setShowIndex}
            pickData={handlePickData}
          />
        }
      />

      {/* 排放源選擇開窗 */}
      <EmissionSourceDialog
        visible={showEmissionSourceDialog}
        onClose={() => setShowEmissionSourceDialog(false)}
        onConfirm={handleEmissionSourcePick}
        sourceList={sourceList}
        currentSourceName={getValues("sourceName") || ""} // 傳入當前選中的排放源名稱
        // title={t('select_emission_source')} // 移除，使用組件內部預設標題
      />
    </>
  );
};

export default AddItem;
